import { useRouter } from 'next/router';
import React, { useEffect } from 'react';
import Layout from '../components/layout/layout';
import { homepageRoute } from '../domain/websiteDomain';

interface BrowseProps {}

const Browse: React.FC<BrowseProps> = () => {
  const router = useRouter();

  useEffect(() => {
    if (typeof window !== 'undefined') {
      router.push(homepageRoute);
    }
  }, [router]);

  return <Layout title="Home"></Layout>;
};

export default Browse;
